import _defaultTo from 'lodash/defaultTo';
import _get from 'lodash/get';
import _orderBy from 'lodash/orderBy';
import _sortBy from 'lodash/sortBy';
// Serialization
import { deserialize, serialize } from 'serializr';
import { priceGridSchema } from './schemas';
// Fragments
import { priceGridFragment } from './fragments';
// Custom
import { findInList } from '../../utils/Tools';

/**
* Serialization
*/
const deserializePriceGrid = (data) => deserialize(priceGridSchema, data);

const serializePriceGrid = ({
  name, tiers, additional,
}) => ({
  ...serialize(priceGridSchema, {
    name: _defaultTo(name, null),
    tiers: _defaultTo(tiers, []),
    additional: _defaultTo(additional, null),
  }),
});

/**
* List
*/
const priceGridUnits = [
  {
    key: 'minute',
    labelId: 'priceGridTier.unit.minute',
    value: 'minute',
    maxDuration: 59,
  },
  {
    key: 'hour',
    labelId: 'priceGridTier.unit.hour',
    value: 'hour',
    maxDuration: 23,
  },
  {
    key: 'day',
    labelId: 'priceGridTier.unit.day',
    value: 'day',
    maxDuration: 365,
  },
];

/**
* Getters
*/
const priceGetGridUnitMinute = priceGridUnits[0];

/**
* Utils
*/
const sortPriceGrids = (priceGrids, fields = ['name'], dirs = ['asc']) => _orderBy(priceGrids, fields, dirs);

const priceGridIsFree = (priceGrid) => priceGrid.tiers && priceGrid.tiers.every((tier) => tier.amountInclTax === 0);

const priceGridTitle = (priceGridData) => _get(priceGridData, 'name', '');

const sortPriceGridTiers = (priceGrid) => _sortBy(
  priceGrid.tiers,
  [
    ({ unit }) => {
      if (unit === 'minute') {
        return 0;
      } if (unit === 'hour') {
        return 1;
      } if (unit === 'day') {
        return 2;
      }
    },
    'duration',
  ],
);

const priceGridTierKey = ({ duration, unit }) => `${duration}_${unit}`;

const priceGridTierUnit = (tier) => findInList(priceGridUnits, 'value', tier, 'unit');

/**
* GraphQL
*/
const queListPriceGrids = `
  query ListPriceGrids($input: ListPriceGridsInput!, $search: ListPriceGridsSearchInput) {
    listPriceGrids(input: $input, search: $search) {
      ...priceGridFragment
    }
  }

  ${priceGridFragment}
`;

const queGetPriceGrid = `
  query GetPriceGrid($input: GetPriceGridInput!) {
    getPriceGrid(input: $input) {
      ...priceGridFragment
    }
  }

  ${priceGridFragment}
`;

const mutAddPriceGrid = `
  mutation AddPriceGrid($input: AddPriceGridInput!) {
    addPriceGrid(input: $input) {
      id
    }
  }
`;

const mutUpdatePriceGrid = `
  mutation UpdatePriceGrid($input: UpdatePriceGridInput!) {
    updatePriceGrid(input: $input) {
      id
    }
  }
`;

/**
* Model
*/
const priceGrid = {
  // Name
  name: 'priceGrid',

  // Serialization
  deserialize: deserializePriceGrid,
  serialize: serializePriceGrid,

  // Sort elements
  sortElements: sortPriceGrids,

  priceGridIsFree,

  // Lists
  units: priceGridUnits,

  // Getters
  getGridUnitMinute: priceGetGridUnitMinute,

  // Utils
  title: priceGridTitle,
  sortTiers: sortPriceGridTiers,
  tierKey: priceGridTierKey,
  tierUnit: priceGridTierUnit,

  // GraphQL
  queListPriceGrids,
  queGetPriceGrid,
  mutAddPriceGrid,
  mutUpdatePriceGrid,
};

module.exports = priceGrid;



// WEBPACK FOOTER //
// ./models/cpm/priceGrid.js